var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcModifyStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 4.5,
    fill: "white",
    stroke: "#B5B5B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8398_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 27.5C14.2152 27.5 11.5445 26.3938 9.57538 24.4246C7.60625 22.4555 6.5 19.7848 6.5 17C6.5 14.2152 7.60625 11.5445 9.57538 9.57538C11.5445 7.60625 14.2152 6.5 17 6.5C22.7983 6.5 27.5 10.679 27.5 15.8333C27.5 17.07 26.947 18.2577 25.9623 19.1327C24.9777 20.0077 23.6418 20.5 22.25 20.5H19.3333C18.8128 20.4916 18.3045 20.6575 17.8891 20.9713C17.4738 21.2851 17.1753 21.7288 17.0412 22.2318C16.9071 22.7348 16.945 23.2682 17.1489 23.7472C17.3529 24.2261 17.7111 24.6231 18.1667 24.875C18.3996 25.0899 18.5594 25.3725 18.6235 25.6829C18.6876 25.9933 18.6528 26.316 18.5241 26.6056C18.3954 26.8953 18.1791 27.1373 17.9058 27.2977C17.6324 27.4581 17.3156 27.5289 17 27.5Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.2487C11.75 15.5581 11.8729 15.8549 12.0917 16.0737C12.3105 16.2924 12.6072 16.4154 12.9167 16.4154C13.2261 16.4154 13.5228 16.2924 13.7416 16.0737C13.9604 15.8549 14.0833 15.5581 14.0833 15.2487C14.0833 14.9393 13.9604 14.6425 13.7416 14.4237C13.5228 14.2049 13.2261 14.082 12.9167 14.082C12.6072 14.082 12.3105 14.2049 12.0917 14.4237C11.8729 14.6425 11.75 14.9393 11.75 15.2487Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 11.7487C16.4167 12.0581 16.5397 12.3549 16.7585 12.5737C16.9772 12.7924 17.274 12.9154 17.5834 12.9154C17.8928 12.9154 18.1896 12.7924 18.4084 12.5737C18.6272 12.3549 18.7501 12.0581 18.7501 11.7487C18.7501 11.4393 18.6272 11.1425 18.4084 10.9237C18.1896 10.7049 17.8928 10.582 17.5834 10.582C17.274 10.582 16.9772 10.7049 16.7585 10.9237C16.5397 11.1425 16.4167 11.4393 16.4167 11.7487Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 15.2487C21.0833 15.5581 21.2062 15.8549 21.425 16.0737C21.6438 16.2924 21.9405 16.4154 22.2499 16.4154C22.5593 16.4154 22.8561 16.2924 23.0749 16.0737C23.2937 15.8549 23.4166 15.5581 23.4166 15.2487C23.4166 14.9393 23.2937 14.6425 23.0749 14.4237C22.8561 14.2049 22.5593 14.082 22.2499 14.082C21.9405 14.082 21.6438 14.2049 21.425 14.4237C21.2062 14.6425 21.0833 14.9393 21.0833 15.2487Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8398_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModifyStyle);
export default __webpack_public_path__ + "static/media/ic-modify-style.853eac70669650ca4212bf95f2fc5464.svg";
export { ForwardRef as ReactComponent };